<template>
	<div>
		<v-app-bar app flat :color="scrolled ? 'rgba(26, 26, 26, 0.95)' : 'brown'" :class="['sg-app-bar', { 'sg-app-bar--scrolled': scrolled }]" height="72">
			<v-container class="py-0">
				<v-row align="center" no-gutters>
					<v-col cols="auto" class="d-flex align-center">
						<v-img src="/logo-wide.png" contain max-height="42" max-width="160" class="sg-logo" />
					</v-col>

					<v-col class="d-none d-md-flex justify-center">
						<v-btn v-for="item in navItems" :key="item.id" text class="sg-nav-link white--text mx-1" @click="scrollTo(item.id)">
							{{ item.label }}
						</v-btn>
					</v-col>

					<v-col cols="auto" class="d-flex align-center">
						<v-btn v-if="isAdmin" outlined small class="sg-btn-outline ml-2 d-none d-sm-flex" @click="toggleEditMode">
							{{ editMode ? 'خروج از ویرایش' : 'حالت ویرایش' }}
						</v-btn>
						<v-btn outlined class="sg-btn-outline" @click="goToLogin">
							<v-icon left small>mdi-account-outline</v-icon>
							<span class="d-none d-sm-inline">ورود به پنل</span>
						</v-btn>
						<v-app-bar-nav-icon class="d-md-none white--text" @click="drawer = true" />
					</v-col>
				</v-row>
			</v-container>
		</v-app-bar>

		<v-navigation-drawer v-model="drawer" app temporary right class="sg-drawer">
			<v-list nav dense>
				<v-list-item v-for="item in navItems" :key="item.id" @click="scrollTo(item.id); drawer = false">
					<v-list-item-icon>
						<v-icon color="#C9A227">{{ item.icon }}</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ item.label }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider class="my-3" />
				<v-list-item @click="goToLogin">
					<v-list-item-icon><v-icon color="#C9A227">mdi-account-outline</v-icon></v-list-item-icon>
					<v-list-item-content><v-list-item-title>ورود به پنل</v-list-item-title></v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<script>
	import { get, call } from 'vuex-pathify'
	import router from '@/router'

	export default {
		name: 'SafeGoldsAppBar',
		data() {
			return {
				scrolled: false,
				drawer: false,
				navItems: [
					{ id: 'categories', label: 'دسته‌بندی‌ها', icon: 'mdi-diamond-stone' },
					{ id: 'latest', label: 'جدیدترین‌ها', icon: 'mdi-star-outline' },
					{ id: 'benefits', label: 'مزایا', icon: 'mdi-shield-check-outline' },
					{ id: 'testimonials', label: 'نظرات', icon: 'mdi-comment-text-outline' },
					{ id: 'about', label: 'درباره ما', icon: 'mdi-information-outline' },
					{ id: 'secure-buying', label: 'خرید امن', icon: 'mdi-lock-check-outline' },
				],
			}
		},
		computed: {
			...get('auth', ['isAdmin']),
			...get('app', ['editMode']),
		},
		mounted() {
			window.addEventListener('scroll', this.onScroll, { passive: true })
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.onScroll)
		},
		methods: {
			toggleEditMode: call('app/toggleEditMode'),
			onScroll() {
				this.scrolled = window.scrollY > 40
			},
			scrollTo(id) {
				const el = document.getElementById(id)
				if (el) {
					const offset = 80
					const top = el.getBoundingClientRect().top + window.scrollY - offset
					window.scrollTo({ top, behavior: 'smooth' })
				}
			},
			goToLogin() {
				router.push({ name: 'Login' }).catch(() => { })
			},
		},
	}
</script>

<style lang="scss"
	scoped>
		.sg-app-bar {
			transition: background-color 0.4s ease, box-shadow 0.4s ease, backdrop-filter 0.4s ease !important;

			&--scrolled {
				box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35) !important;
				backdrop-filter: blur(12px);
			}
		}

		.sg-nav-link {
			font-size: 0.9rem;
			letter-spacing: 0;
			transition: color 0.25s ease, transform 0.25s ease;

			&:hover {
				color: #D4AF37 !important;
				transform: translateY(-1px);
			}

			&::after {
				content: '';
				display: block;
				width: 0;
				height: 2px;
				background: linear-gradient(90deg, #C9A227, #F5E6A3);
				transition: width 0.3s ease;
				margin: 0 auto;
			}

			&:hover::after {
				width: 60%;
			}
		}

		.sg-btn-outline {
			border-color: #C9A227 !important;
			color: #D4AF37 !important;
			transition: all 0.3s ease;

			&:hover {
				background: rgba(201, 162, 39, 0.15) !important;
				transform: scale(1.03);
			}
		}

		.sg-logo {
			filter: drop-shadow(0 2px 8px rgba(201, 162, 39, 0.3));
			transition: transform 0.3s ease;

			&:hover {
				transform: scale(1.02);
			}
		}

		.sg-drawer {
			background: #1a1a1a !important;
			color: #fff;
		}
	</style>
